import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data, Select3Data } from "../../../utils/common";

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ country_id, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${country_id}?name=${name}`,
      );
      return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCity = createAsyncThunk(
  "common/masters/all-city",
  async ({ state_id, city_name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllCity}/${state_id}?name=${city_name}`,
      );
     // console.log("res...", res);
      return await Select3Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode",
  async ({ city_id, pincode = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${city_id}?name=${pincode}`,
      );
      return await Select3Data(res.data.data, "pincode");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCategory = createAsyncThunk(
  "common/masters/all-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCategory}?name=${filter}`);

      return await Select2Data(res.data.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllSubcategory = createAsyncThunk(
  "common/masters/all-subcategory/:id",
  async ({ category_id, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllSubcategory}/${category_id}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "subcategory_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllHome = createAsyncThunk(
  "common/masters/all-home/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllHome}/${filter}?name=${name}`);

      return await Select2Data(res.data.data, "home_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllServices = createAsyncThunk(
  "common/masters/all-services",
  async (filter = "", { rejectWithValue }) => {
    try {
      //console.log("Thunk started");
      const res = await GET(
        `${APIS.Commons.AllServices}?name=${filter?.name || filter}`,
      );
      // console.log("res...", res);

      return await Select2Data(res.data.data, "service_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAudit = createAsyncThunk(
  "common/audit/all-audit/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAudit}/${filter}?name=${name}`);
      return await Select2Data(res.data.data, "audit_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAboutUs = createAsyncThunk(
  "common/all-about/all-aboutus/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllAboutUs}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "aboutus_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSignatureSkills = createAsyncThunk(
  "common/signatureskills/all-signatureskill/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllSignatureSkills}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "signatureskills_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllVision = createAsyncThunk(
  "common/visionandmission/all-signatureskill/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllVision}/${filter}?name=${name}`);
      return await Select2Data(res.data.data, "visionandmission_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllOurVictory = createAsyncThunk(
  "common/ourvictories/all-allourvictory/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllOurVictory}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "ourvictories_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllServiceDescription = createAsyncThunk(
  "common/services/all-servicedescription/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllServiceDescription}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "servicedescription_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllExceptional = createAsyncThunk(
  "common/services/all-exceptional/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllExceptional}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "exceptionals_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllHighlights = createAsyncThunk(
  "common/services/all-highlights/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllHighlights}/?name=${filter?.name || filter}`,
      );
      return await Select2Data(res.data.data, "highlights_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPhilosophy = createAsyncThunk(
  "common/services/all-philosophies/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPhilosophy}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "highlights_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllExcellence = createAsyncThunk(
  "common/services/all-excellences/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllExcellence}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "highlights_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTestimonial = createAsyncThunk(
  "common/services/all-testimonials/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllTestimonial}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "highlights_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCorporatehospitality = createAsyncThunk(
  "common/services/all-corporatehospitalies/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllCorporatehospitality}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "corporatehospitality_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBrandvalue = createAsyncThunk(
  "common/services/all-brandvalues/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllBrandvalue}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "brandvalue_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllQualitypolicy = createAsyncThunk(
  "common/services/all-qualitypolicies/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllQualitypolicy}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "qualitypolicy_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPrivacypolicy = createAsyncThunk(
  "common/privacypolicy/all-privacypolicies/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPrivacypolicy}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "privacypolicy_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTermscondition = createAsyncThunk(
  "common/termscondition/all-termsconditions/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllTermscondition}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "termscondition_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllContactus = createAsyncThunk(
  "common/contactus/all-termsconditions/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllContactus}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "contactus_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllWhoweare = createAsyncThunk(
  "common/whoweare/all-whoweare/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllWhoweare}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "whoweare_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllOurachievement = createAsyncThunk(
  "common/whoweare/all-termsconditions/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllOurachievement}/${filter}?name=${name}`,
      );
      return await Select2Data(res.data.data, "ourachievement_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


export const Allappsetup = createAsyncThunk(
  "common/appsetup/all-appsetup/:id",
  async ({ filter, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.appsetup}`,
      );
      return await Select2Data(res.data.data, "appsetup_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_subcategory: [],
    all_category: [],
    all_city: [],
    all_home: [],
    all_services: [],
    all_aboutus: [],
    all_signatureskill: [],
    all_visionandmissions: [],
    all_ourvictory: [],
    all_servicedescription: [],
    all_exceptional: [],
    all_highlights: [],
    all_philosophies: [],
    all_excellences: [],
    all_testimonials: [],
    all_corporatehospitalities: [],
    all_brandvalues: [],
    all_qualitypolicies: [],
    all_privacypoicies: [],
    all_termsconditions: [],
    all_whoweare: [],
    all_contactus: [],
    all_ourachievement: [],
    all_appsetup:[],

    //all_pincode[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(AllSubcategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubcategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subcategory = action.payload || [];
      })
      .addCase(AllSubcategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllHome.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHome.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_home = action.payload || [];
      })
      .addCase(AllHome.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllServices.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllServices.fulfilled, (state, action) => {
        //console.log("SERVICES STORED:", action.payload);
        state.all_services = action.payload;
      })
      .addCase(AllServices.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAboutUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAboutUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_aboutus = action.payload || [];
      })
      .addCase(AllAboutUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSignatureSkills.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSignatureSkills.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_signatureskill = action.payload || [];
      })
      .addCase(AllSignatureSkills.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllVision.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllVision.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_visionandmissions = action.payload || [];
      })
      .addCase(AllVision.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllOurVictory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllOurVictory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_visionandmissions = action.payload || [];
      })
      .addCase(AllOurVictory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllServiceDescription.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllServiceDescription.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_servicedescription = action.payload || [];
      })
      .addCase(AllServiceDescription.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllExceptional.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllExceptional.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_exceptionals = action.payload || [];
      })
      .addCase(AllExceptional.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllHighlights.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHighlights.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_highlights = action.payload || [];
      })
      .addCase(AllHighlights.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPhilosophy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPhilosophy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_highlights = action.payload || [];
      })
      .addCase(AllPhilosophy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllExcellence.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllExcellence.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_excellences = action.payload || [];
      })
      .addCase(AllExcellence.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTestimonial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTestimonial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_testimonials = action.payload || [];
      })
      .addCase(AllTestimonial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCorporatehospitality.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCorporatehospitality.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_corporatehospitalities = action.payload || [];
      })
      .addCase(AllCorporatehospitality.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBrandvalue.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBrandvalue.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_brandvalues = action.payload || [];
      })
      .addCase(AllBrandvalue.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllQualitypolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllQualitypolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_qualitypolicies = action.payload || [];
      })
      .addCase(AllQualitypolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPrivacypolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrivacypolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_privacypoicies = action.payload || [];
      })
      .addCase(AllPrivacypolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTermscondition.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermscondition.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_termsconditions = action.payload || [];
      })
      .addCase(AllTermscondition.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllContactus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllContactus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_contactus = action.payload || [];
      })
      .addCase(AllContactus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllWhoweare.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllWhoweare.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whoweare = action.payload || [];
      })
      .addCase(AllWhoweare.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllOurachievement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllOurachievement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_ourachievement = action.payload || [];
      })
      .addCase(AllOurachievement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Allappsetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Allappsetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_appsetup = action.payload || [];
      })
      .addCase(Allappsetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
